import { render, staticRenderFns } from "./JeuxSociete.vue?vue&type=template&id=1c86e7ca"
import script from "./JeuxSociete.vue?vue&type=script&lang=ts"
export * from "./JeuxSociete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports